import { render, staticRenderFns } from "./StoreLayout.vue?vue&type=template&id=56ff129d&scoped=true"
import script from "./StoreLayout.vue?vue&type=script&lang=js"
export * from "./StoreLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff129d",
  null
  
)

export default component.exports